<div class="lendio-deal-stage-display">
    <div class="lendio-stage-status flex items-center my-1 mx-2">
        <div class="stage-indicator mr-1 {{ stage }}"></div>
        <div class="body-extra-small">{{ stageStatusDisplay || '' }}</div>
    </div>
</div>
